import styled from "styled-components";
import iconMenuBurgger from '../../images/icons/icon-menu-burgger.svg';
import { mixinIcon } from '../variables';

export const IconMenuBurgger = styled.i`
    ${mixinIcon({ urlIcon: iconMenuBurgger, width: 18, height: 14 })};
`;